export default "__VITE_ASSET__DILxxlYD__"